import React, { useState, useEffect, useCallback } from 'react'
import { useDispatch, useStore } from 'react-redux'
import { useHistory } from 'react-router-dom'
import Select from 'react-select'
import MasterRecordComponent from './master-record'
import LookupRecordComponent from './lookup-record'
import LocationMasterRecordComponent from './location-master-record'
import { toast } from '../../../CommonComponents/ToastComponent/toast'
import { getChildSuppliers, getMasterSuppliers, assignMaster, addSupplierHistory, getLocationBasedMasterSuppliers, getChildSuppliersWithMasterIds } from '../../../../redux/actions/vendor'
import { UPDATE_SUPPLIERS_SEARCH_LIST, UPDATE_SUPPLIERS_SEARCH_RESULTS } from '../../../../redux/actionTypes/vendor'

const LookupComponent = ({ onShowExportModal, onShowCreateMasterModal, onGoToSupply, checkedRelatedSupplierData, onShowCreateChildModal }) => {
  const dispatch = useDispatch()
  const store = useStore().getState()
  const history = useHistory()
  const {
    vendor: { suppliers, masterSuppliers, locationMasterSuppliers, masterSupplierDetails, isLoadingMasterSupplier, isLoadingChildSupplier, isRemovingFromMaster, isAssigningMaster, isLoadingLocationMasterSupplier, suppliersSearchList, suppliersSearchResults },
    upload: { finalUploadedData },
    auth: { user }
  } = store

  const [lookupTableData, setLookupTableData] = useState([])
  const [selectedChildrens, setSelectedChildrens] = useState([])
  const [lookupUploadedTableData, setLookupUploadedTableData] = useState([])
  const [masterTableData, setMasterTableData] = useState([])
  const [searchList, setSearchList] = useState({})
  const [showOnlyUploadedSuppliers, setShowOnlyUploadedSuppliers] = useState(false)
  const [selectedMasterIds, setSelectedMasterIds] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0)
  const [totalMasterRecords, setTotalMasterRecords] = useState(0)
  const [locationMasterTableData, setLocationMasterTableData] = useState([])
  const [totalLocationMasterRecords, setTotalLocationMasterRecords] = useState(0)
  const [childSearchList, setChildSearchList] = useState({})
  const [masterSearchList, setMasterSearchList] = useState({})
  const [locationMasterSearchList, setLocationMasterSearchList] = useState({})
  const [isChildrenFiltered, setIsChildrenFiltered] = useState(false)
  const [isAssignToMaster, setIsAssignToMaster] = useState(false)
  const [filteredChildrenMasterIds, setFilteredChildrenMasterIds] = useState([])

  const searchColumns = [
    {
      name: 'suppliername',
      label: 'Name'
    },
    {
      name: 'address',
      label: 'Address'
    },
    {
      name: 'city',
      label: 'City'
    },
    {
      name: 'state',
      label: 'State'
    },
    {
      name: 'zip',
      label: 'Zip'
    },
    {
      name: 'phone',
      label: 'Phone Number'
    },
    {
      name: 'email',
      label: 'Email'
    }
  ]

  const searchOptions = [
    {
      label: 'All',
      value: 'all',
    },
    {
      label: 'Child Suppliers',
      value: 'child',
    },
    {
      label: 'Master Suppliers',
      value: 'master',
    },
    {
      label: 'Location Master Suppliers',
      value: 'locationMaster',
    }
  ]

  const [searchTarget, setSearchTarget] = useState(searchOptions[0])

  const filterChildSuppliers = useCallback((searchList) => {
    const tmpLookupData = [...suppliers]?.filter(row => {
      let status = true
      if (Object.keys(searchList).length > 0) {
        Object.keys(searchList).forEach(searchName => {
          const strSearch = searchList[searchName].toString().toUpperCase()
          const strFieldValue = row[searchName]?.toString().toUpperCase() || ""
          if (searchName === 'address') {
            const address1 = row['address1']?.toString().toUpperCase() || ""
            const address2 = row['address2']?.toString().toUpperCase() || ""

            if (strSearch !== "" && (!address1.includes(strSearch) && !address2.includes(strSearch))) {
              status = false
            }
          } else if (strSearch !== "" && !strFieldValue.includes(strSearch)) {
            status = false
          }
        })
      }
      return status
    })
    setLookupTableData(tmpLookupData)
  }, [])//[suppliers]

  const filterUploadedSuppliers = useCallback((searchList) => {
    const tmpUploadedData = [...finalUploadedData]?.filter(row => {
      let status = true
      if (Object.keys(searchList).length > 0) {
        Object.keys(searchList).forEach(searchName => {
          const strFieldValue = row[searchName]?.toString().toUpperCase() || ""
          const strSearch = searchList[searchName].toString().toUpperCase()
          if (searchName === 'address') {
            const address1 = row['address1']?.toString().toUpperCase() || ""
            const address2 = row['address2']?.toString().toUpperCase() || ""

            if (strSearch !== "" && (!address1.includes(strSearch) && !address2.includes(strSearch))) {
              status = false
            }
          } else if (strSearch !== "" && !strFieldValue.includes(strSearch)) {
            status = false
          }
        })
      }
      return status
    })
    setLookupUploadedTableData(tmpUploadedData)
  }, [finalUploadedData])

  const filterMasterSuppliers = useCallback((searchList) => {
    const tmpMasterData = [...masterSuppliers]?.filter(row => {
      let status = true
      if (Object.keys(searchList).length > 0) {
        Object.keys(searchList).forEach(searchName => {
          const strFieldValue = row[searchName]?.toString().toUpperCase() || ""
          const strSearch = searchList[searchName].toString().toUpperCase()
          if (searchName === 'address') {
            const address1 = row['address1']?.toString().toUpperCase() || ""
            const address2 = row['address2']?.toString().toUpperCase() || ""

            if (strSearch !== "" && (!address1.includes(strSearch) && !address2.includes(strSearch))) {
              status = false
            }
          } else if (strSearch !== "" && !strFieldValue.includes(strSearch)) {
            status = false
          }
        })
      }
      return status
    })

    const tmp = tmpMasterData.filter((master) => master !== null)
    setMasterTableData(tmpMasterData)
  }, [])

  const handleClickSearch = async () => {
    if (isLoadingMasterSupplier || isLoadingChildSupplier || isLoadingLocationMasterSupplier) {
      return
    }
    if (Object.keys(searchList).length === 0) {
      toast.show({
        title: 'Warning',
        description: 'Please fill one of the search options!'
      })
      return
    }
    setIsChildrenFiltered(false)
    if (searchTarget.value === 'all') {
      await getMasterSuppliersData(searchList)
      if (selectedChildrens.length === 0) {
        await getChildSuppliersData(searchList)
      }
      await getLocationMasterSuppliersData(searchList)
      setChildSearchList(searchList)
      setMasterSearchList(searchList)
      setLocationMasterSearchList(searchList)
      filterUploadedSuppliers(searchList)
      dispatch({
        type: UPDATE_SUPPLIERS_SEARCH_LIST,
        data: {
          searchTarget: searchTarget,
          all: searchList,
          child: searchList,
          master: searchList,
          locationMaster: searchList
        }
      })
    } else if (searchTarget.value === 'child') {
      if (selectedChildrens.length === 0) {
        await getChildSuppliersData(searchList)
      }
      filterUploadedSuppliers(searchList)
      setMasterSearchList({})
      setLocationMasterSearchList({})
      setChildSearchList(searchList)
      dispatch({
        type: UPDATE_SUPPLIERS_SEARCH_LIST,
        data: {
          searchTarget: searchTarget,
          all: searchList,
          child: searchList,
          master: {},
          locationMaster: {}
        }
      })
    } else if (searchTarget.value === 'master') {
      await getMasterSuppliersData(searchList)
      setLookupUploadedTableData(finalUploadedData)
      setChildSearchList({})
      setLocationMasterSearchList({})
      setMasterSearchList(searchList)
      dispatch({
        type: UPDATE_SUPPLIERS_SEARCH_LIST,
        data: {
          searchTarget: searchTarget,
          all: searchList,
          child: {},
          master: searchList,
          locationMaster: {}
        }
      })
    } else if (searchTarget.value === 'locationMaster') {
      await getLocationMasterSuppliersData(searchList)
      setChildSearchList({})
      setMasterSearchList({})
      setLocationMasterSearchList(searchList)
      dispatch({
        type: UPDATE_SUPPLIERS_SEARCH_LIST,
        data: {
          searchTarget: searchTarget,
          all: searchList,
          child: {},
          master: {},
          locationMaster: searchList
        }
      })
    }
  }

  const getMastersData = useCallback(async () => {
    try {
      await getMasterSuppliersData(suppliersSearchList ? suppliersSearchList : {})
      // await getLocationMasterSuppliersData(suppliersSearchList ? suppliersSearchList : {})
    } catch (err) {
      console.log("err", err)
    }
  }, [])

  useEffect(() => {
    if (suppliersSearchList?.all && Object.keys(suppliersSearchList?.all)?.length > 0) {
      setSearchTarget(suppliersSearchList?.searchTarget || searchOptions[0])
      setSearchList(suppliersSearchList?.all || {})
      setChildSearchList(suppliersSearchList?.child || {})
      setMasterSearchList(suppliersSearchList?.master || {})
      setLocationMasterSearchList(suppliersSearchList?.location || {})
      if (suppliersSearchList?.child && Object.keys(suppliersSearchList?.child)?.length > 0) {
        setLookupTableData(suppliersSearchResults?.childs?.data || [])
        setTotalRecords(suppliersSearchResults?.childs?.total || 0)
      }
      if (suppliersSearchList?.master && Object.keys(suppliersSearchList?.master)?.length > 0) {
        setMasterTableData(suppliersSearchResults?.masters?.data || [])
        setTotalMasterRecords(suppliersSearchResults?.masters?.total || 0)
      } else {
        getMasterSuppliersData({})
      }
      // if (suppliersSearchList?.locationMaster && Object.keys(suppliersSearchList?.locationMaster)?.length > 0) {
      //   setLocationMasterTableData(suppliersSearchResults?.locationMasters?.data || [])
      //   setTotalLocationMasterRecords(suppliersSearchResults?.locationMasters?.total || 0)
      // } else {
      //   getLocationMasterSuppliersData({})
      // }
    } else {
      getMastersData()
    }
  }, [dispatch, getMastersData])

  useEffect(() => {
    if (history?.location?.pathname && history?.location?.pathname === '/suppliers/guid') {
      setShowOnlyUploadedSuppliers(history?.location?.state?.isJustFileUploaded || false)
    }
  }, [history])

  // useEffect(() => {
  //   if (suppliersSearchList && Object.keys(suppliersSearchList)?.length > 0) {
  //     return
  //   }
  //   if (!suppliers || suppliers.length === 0) {
  //     return
  //   }
  //   if (searchTarget.value === 'all' || searchTarget.value === 'child') {
  //     filterChildSuppliers(searchList)
  //   } else if (searchTarget.value === 'master') {
  //     setLookupTableData(suppliers)
  //   }
  //   // eslint-disable-next-line
  // }, [suppliers, filterChildSuppliers])

  useEffect(() => {
    if (!finalUploadedData || finalUploadedData.length === 0) {
      return
    }
    if (searchTarget.value === 'all' || searchTarget.value === 'child') {
      filterUploadedSuppliers(searchList)
    } else if (searchTarget.value === 'master') {
      setLookupUploadedTableData(finalUploadedData)
    }
    // eslint-disable-next-line
  }, [finalUploadedData, filterUploadedSuppliers])

  useEffect(() => {
    if (suppliersSearchList && Object.keys(suppliersSearchList)?.length > 0) {
      return
    }
    if (!masterSuppliers || masterSuppliers.length === 0) {
      return
    }
    if (searchTarget.value === 'all' || searchTarget.value === 'master') {
      filterMasterSuppliers(searchList)
    } else if (searchTarget.value === 'child') {
      setMasterTableData(masterSuppliers)
    }
    // eslint-disable-next-line
  }, [masterSuppliers, filterMasterSuppliers])

  const handleChangeSearch = (searchKey, colName) => {
    const tmpSearchList = { ...searchList }
    tmpSearchList[colName] = searchKey
    // dispatch({
    //   type: UPDATE_SUPPLIERS_SEARCH_LIST,
    //   data: {
    //     child: {},
    //     master: {},
    //     locationMaster: {}
    //   }
    // })
    setSearchList(tmpSearchList)
    // if (searchTarget.value === 'all') {
    //   setChildSearchList(tmpSearchList)
    //   setMasterSearchList(tmpSearchList)
    //   setLocationMasterSearchList(tmpSearchList)
    // }
    // if (searchTarget.value === 'child') {
    //   setChildSearchList(tmpSearchList)
    // }
    // if (searchTarget.value === 'master') {
    //   setMasterSearchList(tmpSearchList)
    // }
    // if (searchTarget.value === 'locationMaster') {
    //   setLocationMasterSearchList(tmpSearchList)
    // }
  }

  const handleChangeSearchOption = (searchOption) => {
    if (searchOption.value === 'child') {
      dispatch({
        type: UPDATE_SUPPLIERS_SEARCH_LIST,
        data: {
          searchTarget: searchTarget,
          all: searchList,
          child: searchList,
          master: {},
          locationMaster: {}
        }
      })
      setMasterSearchList({})
      setLocationMasterSearchList({})
    }
    if (searchOption.value === 'master') {
      dispatch({
        type: UPDATE_SUPPLIERS_SEARCH_LIST,
        data: {
          searchTarget: searchTarget,
          all: searchList,
          child: {},
          master: searchList,
          locationMaster: {}
        }
      })
      setChildSearchList({})
      setLocationMasterSearchList({})
    }
    if (searchOption.value === 'locationMaster') {
      dispatch({
        type: UPDATE_SUPPLIERS_SEARCH_LIST,
        data: {
          searchTarget: searchTarget,
          all: searchList,
          child: {},
          master: {},
          locationMaster: searchList
        }
      })
      setChildSearchList({})
      setMasterSearchList({})
    }
    setSearchTarget(searchOption)
  }

  const handleClickClearSearch = () => {
    dispatch({
      type: UPDATE_SUPPLIERS_SEARCH_LIST,
      data: {
        searchTarget: searchOptions[0],
        all: {},
        child: {},
        master: {},
        locationMaster: {}
      }
    })
    dispatch({
      type: UPDATE_SUPPLIERS_SEARCH_RESULTS,
      data: {
        masters: {},
        childs: {},
        locationMasters: {}
      }
    })
    setIsChildrenFiltered(false)
    setSearchList({})
    setChildSearchList({})
    setMasterSearchList({})
    setSearchTarget(searchOptions[0])
    setLocationMasterSearchList({})
    getLocationMasterSuppliersData()
    getMasterSuppliersData()
    if (selectedChildrens.length === 0) {
      getChildSuppliersData()
    }
  }

  const handleCheckUploadedSuppliers = (checked) => {
    setShowOnlyUploadedSuppliers(checked)
  }

  const handleShowChildrensForMasters = async (masterIds) => {
    // show children clicked
    if (masterIds && masterIds.length > 0) {
      setIsChildrenFiltered(true)
      setFilteredChildrenMasterIds(masterIds)
      await dispatch(getChildSuppliersWithMasterIds(masterIds, 10, 0)).then(async (res) => {
        setLookupTableData(res?.childSuppliers)
        setTotalRecords(res?.totalChilds || 0)
        // setSelectedChildrens(res?.childSuppliers)
      }).catch(() => {
        setLookupTableData([])
        setTotalRecords(0)
        toast.show({
          title: 'Warning',
          description: 'Failed to get child suppliers for the selected master records!'
        })
      })
      // setSelectedChildrens([...suppliers.filter(supplier => masterIds.includes(supplier.masterId))])
      // setLookupTableData([])
      return
    }
    // show all children clicked
    setSelectedChildrens([])
    setChildSearchList({})
    setIsChildrenFiltered(false)
    setFilteredChildrenMasterIds([])
    dispatch({
      type: UPDATE_SUPPLIERS_SEARCH_LIST,
      data: {
        searchTarget: searchTarget,
        all: searchList,
        child: {},
        master: searchList,
        locationMaster: searchList
      }
    })
    // if (Object.keys(searchList).length > 0) {
    dispatch(getChildSuppliers({
      limit: 10,
      offset: 0,
      searchList: {},
      noMaster: false,
      hasMaster: false
    })).then(async (res) => {
      setLookupTableData(res?.childSuppliers)
      setTotalRecords(res?.totalChilds || 0)
    })
    // }
  }

  const handleSearchSimiliarVendors = (vendorIds) => {
    const tmpSelectedSuppliers = suppliers.filter(supplier => vendorIds.includes(supplier.id))
    const matchedSuppliers = suppliers.filter(supplier => {
      const isMatched = tmpSelectedSuppliers.filter(selectedSupplier => {
        if (selectedSupplier.suppliername !== supplier.suppliername) {
          return false
        }
        if (selectedSupplier.address1 !== supplier.address1) {
          return false
        }
        if (selectedSupplier.phone !== supplier.phone) {
          return false
        }
        if (selectedSupplier.email && selectedSupplier.email !== '') {
          return supplier.email?.includes(selectedSupplier.email.split("@")[1])
        }
        return true
      }).length > 0
      return isMatched
    })
    setLookupTableData(matchedSuppliers)
    setShowOnlyUploadedSuppliers(false)
  }

  const handleSelectMaster = (id) => {
    if (!id || id === undefined) {
      setSelectedMasterIds([])
      return
    }
    if (!selectedMasterIds || selectedMasterIds.length === 0) {
      setSelectedMasterIds([id])
      return
    }
    const isExisted = selectedMasterIds.findIndex(masterId => masterId === id)
    if (isExisted !== -1) {
      setSelectedMasterIds([...selectedMasterIds.filter(masterId => masterId !== id)])
    } else {
      setSelectedMasterIds([...selectedMasterIds, id])
    }
  }

  const handleAssignMaster = (ids, showHasMaster, showNoMaster, page) => {
    if (!selectedMasterIds || selectedMasterIds.length === 0 || selectedMasterIds.length > 1) {
      toast.show({
        title: 'Warning',
        description: 'You must select one master supplier'
      })
      return
    }
    dispatch(
      assignMaster(ids, selectedMasterIds[0])
    ).then((response) => {
      setIsAssignToMaster(true)
      toast.show({
        title: 'Success',
        description: 'Assign to master successfully!',
      })
      let note = 'Child supplier assigned to Master ' + '<a target="_blank" href="/suppliers/' + response?.masterInfo?.id + '"><b>' + response?.masterInfo?.suppliername + '</b></a> by <b><em>' + user.firstname + ' ' + user.lastname + '</em></b>';
      dispatch(
        addSupplierHistory({
          supplierId: ids,
          note: note,
          noteType: 'changelog'
        })
      )
      setSelectedMasterIds([])
      getChildSuppliersData(searchList, showHasMaster, showNoMaster, page, true)
    })
  }

  // to get the data of the child supplier whose name is clicked
  const checkedRelatedSupplierRow = (data) => {
    checkedRelatedSupplierData({ data, isAcceptGlobalAcceptance: data?.[0]?.masterSupplierInfo?.cardAcceptance?.isAcceptGlobalAcceptance });
  };

  const getChildSuppliersData = async (searchList = {}, showHasMaster = false, showNoMaster = false, page = 1, isAssigningToMaster = false) => {
    await dispatch(getChildSuppliers({
      limit: 10,
      offset: 10 * (page - 1),
      searchList,
      noMaster: showNoMaster,
      hasMaster: showHasMaster
    })).then(async (res) => {
      setLookupTableData(res?.childSuppliers)
      setTotalRecords(res?.totalChilds || 0)
      if (Object.keys(searchList)?.length > 0) {
        dispatch({
          type: UPDATE_SUPPLIERS_SEARCH_RESULTS,
          data: {
            childs: {
              data: res === undefined ? [] : res?.childSuppliers,
              total: res?.totalChilds || 0
            }
          }
        })
      }
      if (isAssigningToMaster) {
        setIsAssignToMaster(false)
      }
    })
  }

  const getMasterSuppliersData = async (searchList = {}) => {
    await dispatch(getMasterSuppliers({
      limit: 10,
      offset: 0,
      searchList,
      // sortColumn: 'id',
      // sortType: 'asc'
    })).then(async (masterRes) => {
      setMasterTableData(masterRes?.masterSuppliers)
      setTotalMasterRecords(masterRes?.totalMasters || 0)
      if (Object.keys(searchList).length > 0) {
        dispatch({
          type: UPDATE_SUPPLIERS_SEARCH_RESULTS,
          data: {
            masters: {
              data: masterRes?.masterSuppliers,
              total: masterRes?.totalMasters || 0
            }
          }
        })
      }
    })
  }

  const getLocationMasterSuppliersData = async (searchList = {}) => {
    await dispatch(getLocationBasedMasterSuppliers({
      limit: 10,
      offset: 0,
      searchList
    })).then(async (locationMasterRes) => {
      setLocationMasterTableData(locationMasterRes.locationMasters)
      setTotalLocationMasterRecords(locationMasterRes?.totalLocationMasters || 0)
      if (Object.keys(searchList).length > 0) {
        dispatch({
          type: UPDATE_SUPPLIERS_SEARCH_RESULTS,
          data: {
            locationMasters: {
              data: locationMasterRes?.locationMasters,
              total: locationMasterRes?.totalLocationMasters || 0
            }
          }
        })
      }
    })
  }

  const handleKeyDown = (e) => {
    if (e.which === 13) {
      handleClickSearch()
    }
  }

  return (
    <div className="assign-vendor-lookup">
      <div className="card">
        <div className="card-content search-bar flex flex-wrap justify-space-between algin-center">
          <div className="search-input-container">
            {
              searchColumns.map(column => (
                <div className="search-input-item" key={column.label}>
                  <input
                    type="text"
                    value={searchList[column.name] || ''}
                    className="search-input"
                    placeholder={column.label}
                    onChange={(e) => { handleChangeSearch(e.target.value, column.name) }}
                    onKeyDown={handleKeyDown}
                  />
                </div>
              ))
            }
          </div>
          <div className="search-action">
            <div className="option-selector h4">
              <Select
                value={searchTarget}
                options={searchOptions}
                className="select-searchoption"
                onChange={handleChangeSearchOption}
                onKeyDown={handleKeyDown}
              />
            </div>
            <div className="button-group">
              <button type="button" className="btn btn-gray search" onClick={() => { handleClickSearch() }}
                disabled={isLoadingMasterSupplier || isLoadingChildSupplier || isRemovingFromMaster || isAssigningMaster || isLoadingLocationMasterSupplier}
              >
                {isLoadingMasterSupplier || isLoadingChildSupplier || isLoadingLocationMasterSupplier ? "Please wait..." : "Search"}
              </button>
              <button type="button" className="btn btn-gray clear" onClick={handleClickClearSearch}
                disabled={isLoadingMasterSupplier || isLoadingChildSupplier || isRemovingFromMaster || isAssigningMaster || isLoadingLocationMasterSupplier}
              >
                Clear
              </button>
            </div>
          </div>
        </div>
      </div>
      <MasterRecordComponent
        onShowExportModal={onShowExportModal}
        tableData={masterTableData}
        masterSuppliers={masterSuppliers}
        onGoToMasterDetail={onGoToSupply}
        onSelectChildren={handleShowChildrensForMasters}
        onSelectMaster={handleSelectMaster}
        selectedMasterIds={selectedMasterIds}
        totalMasterRecords={totalMasterRecords}
        searchList={masterSearchList}
        locationSearchList={locationMasterSearchList}
        searchTarget={searchTarget.value}
        locationMasterTableData={locationMasterTableData}
        locationMasterSuppliers={locationMasterSuppliers}
      />

      <LookupRecordComponent
        onShowExportModal={onShowExportModal}
        onShowCreateMasterModal={onShowCreateMasterModal}
        onAssignMaster={handleAssignMaster}
        tableData={lookupTableData}
        finalUploadedData={lookupUploadedTableData}
        selectedChildrens={selectedChildrens}
        onSearchSimiliarVendors={handleSearchSimiliarVendors}
        showOnlyUploadedSuppliers={showOnlyUploadedSuppliers}
        onCheckUploadedSuppliers={handleCheckUploadedSuppliers}
        masterSuppliers={masterSuppliers}
        checkedRelatedSupplierRow={checkedRelatedSupplierRow}
        totalRecords={totalRecords}
        searchList={childSearchList}
        searchTarget={searchTarget.value}
        onAddChildSupplier={onShowCreateChildModal}
        isChildrenFiltered={isChildrenFiltered}
        filteredChildrenMasterIds={filteredChildrenMasterIds}
        isAssigningToMaster={isAssignToMaster}
      />

      {/* <LocationMasterRecordComponent
        onShowExportModal={onShowExportModal}
        tableData={locationMasterTableData}
        locationMasterSuppliers={locationMasterSuppliers}
        onGoToMasterDetail={onGoToSupply}
        totalLocationMasterRecords={totalLocationMasterRecords}
        searchList={locationMasterSearchList}
      /> */}
    </div>
  )
}

export default LookupComponent
